module.exports = __webpack_public_path__ + "static/media/close.377d6c96.svg";